import Annotation from "./Annotation";
import TextSection from "./TextSection";
import Project from "./Project";
import Text from "./Text";
import Resource from "./Resource";
import Journal from "./Journal";
import Issue from "./JournalIssue";
import Volume from "./JournalVolume";

export default {
  Annotation,
  TextSection,
  Project,
  Text,
  Resource,
  Journal,
  Issue,
  Volume
};
